import { getToken, reportNameOptions } from "helper/common";
import {
    CLEAR_REPORT_GENERATION_DETAILS,
    CLEAR_REPORT_GENERATION_LIST,
    SET_REPORT_GENERATION_DETAILS,
    SET_REPORT_GENERATION_LIST,
    REPORT_GENERATION_CREATE_DIALOG_CLOSE,
    REPORT_GENERATION_CREATE_DIALOG_OPEN,
    REPORT_GENERATION_CREATE_ERROR,
    REPORT_GENERATION_CREATE_ERROR_CLEAR,
    REPORT_GENERATION_CREATE_PENDING,
    REPORT_GENERATION_DETAILS_ERROR,
    REPORT_GENERATION_DETAILS_ERROR_CLEAR,
    REPORT_GENERATION_DETAILS_PENDING,
    REPORT_GENERATION_EDIT_DIALOG_CLOSE,
    REPORT_GENERATION_EDIT_DIALOG_OPEN,
    REPORT_GENERATION_EDIT_ERROR,
    REPORT_GENERATION_EDIT_ERROR_CLEAR,
    REPORT_GENERATION_EDIT_PENDING,
    REPORT_GENERATION_LIST_ERROR,
    REPORT_GENERATION_LIST_ERROR_CLEAR,
    REPORT_GENERATION_LIST_PENDING,
    SET_REPORT_SIDEBAR_LIST,
    REPORT_GENERATION_DATA,
    FIELDS_TABLE_DIALOG_OPEN,
    FIELDS_TABLE_DIALOG_CLOSE,
    SET_CURRENT_BIRD_RECORD,
    SET_REPORT_FILTER_DATA,
    REPORT_FILTER_DIALOG_OPEN,
    REPORT_FILTER_DIALOG_CLOSE,
} from "./constants";
import agent from "store/service/agent";
import { openSnackbar } from "store/slices/snackbar";
import { trimmedValues } from "helper/trim";
// import { encodeObjectValues } from "helper/encodeData";

//-----------------------------|| LIST ||---------------------------------------------------------------
export const setReportGenerationList = (reportGenerationList) => ({
    type: SET_REPORT_GENERATION_LIST,
    payload: { reportGenerationList }
});

export const clearReportGenerationList = () => ({
    type: CLEAR_REPORT_GENERATION_LIST,
});

export const reportGenerationListPending = () => ({
    type: REPORT_GENERATION_LIST_PENDING
});

export const reportGenerationListError = (errorMessage) => ({
    type: REPORT_GENERATION_LIST_ERROR,
    payload: { errorMessage }
});

export const reportGenerationListErrorClear = () => ({
    type: REPORT_GENERATION_LIST_ERROR_CLEAR
});

export const openFieldsTableDialog = () => ({
    type: FIELDS_TABLE_DIALOG_OPEN
});

export const closeFieldsTableDialog = () => ({
    type: FIELDS_TABLE_DIALOG_CLOSE
});

export const setCurrentBirdsRecord = (birdRecord, farmName, reportName, reportValue) => ({
    type: SET_CURRENT_BIRD_RECORD,
    payload: { birdRecord, farmName, reportName, reportValue },
});

export const getReportGenerationList = (page, pageSize, sortOrder, sortDirection, reportData, filters) => (dispatch) => {
    // const encodeFilters = encodeObjectValues({ ...filter })
    dispatch(reportGenerationListPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.formulae.getReportGenerationList(accessToken, page, pageSize, sortOrder, sortDirection, reportData, filters)
            .then((reportGenerationList) => {
                dispatch(setReportGenerationList(reportGenerationList));
                dispatch(reportGenerationListErrorClear());
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(reportGenerationListError(message));
                }
                else {
                    dispatch(reportGenerationListError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| FILTER ||-------------------------------------------------------------
export const openReportFilterDialog = () => ({
    type: REPORT_FILTER_DIALOG_OPEN
});

export const closeReportFilterDialog = () => ({
    type: REPORT_FILTER_DIALOG_CLOSE
});

export const setReportFilteredData = (filter) => ({
    type: SET_REPORT_FILTER_DATA,
    payload: { filter },
});

//-----------------------------|| DETAILS ||---------------------------------------------------------------
export const setReportGenerationDetails = (reportGenerationDetails) => ({
    type: SET_REPORT_GENERATION_DETAILS,
    payload: { reportGenerationDetails }
});

export const clearReportGenerationDetails = () => ({
    type: CLEAR_REPORT_GENERATION_DETAILS,
});

export const reportGenerationDetailsPending = () => ({
    type: REPORT_GENERATION_DETAILS_PENDING
});

export const reportGenerationDetailsError = (errorMessage) => ({
    type: REPORT_GENERATION_DETAILS_ERROR,
    payload: { errorMessage }
});

export const reportGenerationDetailsErrorClear = () => ({
    type: REPORT_GENERATION_DETAILS_ERROR_CLEAR
});

export const getReportGenerationDetails = (id) => (dispatch) => {
    dispatch(reportGenerationDetailsPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.reportGenerations.getReportGenerationDetails(accessToken, id)
            .then((reportGenerationDetails) => {
                dispatch(setReportGenerationDetails(reportGenerationDetails));
                dispatch(reportGenerationDetailsErrorClear());
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(reportGenerationDetailsError(message));
                }
                else {
                    dispatch(reportGenerationDetailsError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| CREATE ||---------------------------------------------------------------
export const reportGenerationData = (reportData) => ({
    type: REPORT_GENERATION_DATA,
    payload: { reportData }
});

export const openReportGenerationCreateDialog = () => ({
    type: REPORT_GENERATION_CREATE_DIALOG_OPEN
});

export const closeReportGenerationCreateDialog = () => ({
    type: REPORT_GENERATION_CREATE_DIALOG_CLOSE
});

export const reportGenerationCreatePending = () => ({
    type: REPORT_GENERATION_CREATE_PENDING
});

export const reportGenerationCreateError = (errorMessage) => ({
    type: REPORT_GENERATION_CREATE_ERROR,
    payload: { errorMessage }
});

export const reportGenerationCreateErrorClear = () => ({
    type: REPORT_GENERATION_CREATE_ERROR_CLEAR
});

export const reportGenerationCreate = (formData) => (dispatch) => {
    const dataToSend = trimmedValues({ ...formData })
    dispatch(reportGenerationCreatePending());
    return getToken(dispatch).then((accessToken) => {
        return agent.reportGenerations.reportGenerationCreate(accessToken, dataToSend)
            .then(() => {
                dispatch(getReportGenerationList());
                dispatch(reportGenerationCreateErrorClear());
                dispatch(closeReportGenerationCreateDialog());
                dispatch(openSnackbar({
                    open: true,
                    message: 'ReportGeneration successfully created.',
                    variant: 'alert',
                    close: false
                }))
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(reportGenerationCreateError(message));
                }
                else {
                    dispatch(reportGenerationCreateError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| EDIT ||---------------------------------------------------------------
export const openReportGenerationEditDialog = () => ({
    type: REPORT_GENERATION_EDIT_DIALOG_OPEN
});

export const closeReportGenerationEditDialog = () => ({
    type: REPORT_GENERATION_EDIT_DIALOG_CLOSE
});

export const reportGenerationEditPending = () => ({
    type: REPORT_GENERATION_EDIT_PENDING
});

export const reportGenerationEditError = (errorMessage) => ({
    type: REPORT_GENERATION_EDIT_ERROR,
    payload: { errorMessage }
});

export const reportGenerationEditErrorClear = () => ({
    type: REPORT_GENERATION_EDIT_ERROR_CLEAR
});

export const reportGenerationEdit = (formData) => (dispatch) => {
    const dataToSend = trimmedValues({ ...formData })
    dispatch(reportGenerationEditPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.reportGenerations.reportGenerationEdit(accessToken, dataToSend)
            .then(() => {
                dispatch(getReportGenerationDetails(formData?.id));
                dispatch(reportGenerationEditErrorClear());
                dispatch(closeReportGenerationEditDialog());
                dispatch(openSnackbar({
                    open: true,
                    message: 'ReportGeneration details successfully updated.',
                    variant: 'alert',
                    close: false
                }))
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error?.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(reportGenerationEditError(message));
                }
                else {
                    dispatch(reportGenerationEditError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//------------------------------|| Side Bar||---------------------------------------------------//

export const setReportListSideBar = (reportList) => ({
    type: SET_REPORT_SIDEBAR_LIST,
    payload: { reportList }
});

export const getReportsName = (filter, page, pageSize) => (dispatch) => {
    return getToken(dispatch).then((accessToken) => {
        return agent.formulae.getFormulaeName(accessToken, filter, page, pageSize)
            .then((reportList) => {
                dispatch(setReportListSideBar(reportList));
                const reportOptions = reportNameOptions(reportList['value']);
                return Promise.resolve(reportOptions)
            })
            .catch(() => {
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
                return Promise.reject()
            })
    })
}
